/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InviteService, ModalService } from '@shared/services';
import { AthleteInvitation } from '@shared/models/menu.model';
import { first } from 'rxjs/operators';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { forkJoin } from 'rxjs';
import { UserData } from '@shared/models/user.model';
import { ProductDTO } from '@shared/models/product.model';

@Component({
  selector: '[invitePendingModal]',
  templateUrl: './invite-pending-modal.component.html',
  styleUrls: ['./invite-pending-modal.component.scss'],
})
export class InvitePendingModalComponent implements OnInit {
  @Input() invite: AthleteInvitation;
  @Input() currentUser: UserData;
  @Input() products: ProductDTO[];
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  processing = false;

  constructor(private inviteService: InviteService, private modalService: ModalService) {}

  ngOnInit() {}

  send() {
    this.processing = true;
    this.inviteService.sendInviteEmail(this.invite.email, this.invite.invite.id).subscribe((result) => {
      this.close(true);
    });
  }

  cancelClick() {
    this.processing = true;
    const deleteConfirmation = this.modalService.showModal(ConfirmationModalComponent, {
      title: 'Confirm',
      message: 'Are you sure you want to delete this invitation?',
      confirmCTA: 'Delete',
      confirmClass: 'btn-red',
    });
    deleteConfirmation.closeModal.pipe(first()).subscribe((data) => {
      if (data.confirm) {
        // get all invitations for this email
        const invitesToDelete = this.products.reduce((acc, product) => {
          // if no invites for purchase
          if (!product.invites || !product.invites.length) {
            return acc;
          }

          const invitesForEnail = product.invites.filter((invite) => invite.inviteeEmail === this.invite.email);

          return [...acc, ...invitesForEnail];
        }, []);
        this.deleteInvitations(invitesToDelete);
        return;
      } else {
        this.modalService.hideModal();
      }
    });
  }

  deleteInvitations(invites) {
    forkJoin(invites.map((invite) => this.inviteService.deleteInvite(invite.id))).subscribe((response) => {
      this.close(true);
    });
  }

  close(shouldRefresh = false) {
    this.modalService.hideModal();
    this.closeModal.emit(shouldRefresh);
  }
}
